module.exports = __webpack_public_path__ + "account/assets/porject-finish-icon.a54db117.svg";